import * as React from "react"
import cx from "classnames"

import * as styles from "./styles.module.scss"

export interface ButtonProps {
  active?: boolean
  heading: string
  headingSize?: HeadingSize
  onClick?: () => void
  subhead?: string
}

export enum HeadingSize {
  Medium = "medium",
  Large = "large",
}

const Button: React.FC<ButtonProps> = ({
  active,
  heading,
  headingSize = HeadingSize.Medium,
  onClick,
  subhead,
}) => {
  return (
    <a
      className={styles.button}
      onTouchStart={() => true}
      onClick={onClick}
      role="button"
    >
      <h4
        className={cx({
          [styles.heading]: true,
          [styles.large]: headingSize === HeadingSize.Large,
          [styles.medium]: headingSize === HeadingSize.Medium,
        })}
      >
        {heading}
      </h4>
      {subhead && <p className={styles.subhead}>{subhead}</p>}
      {active && (
        <span className={styles.selected}>
          <i className="bsk-icon-checkmark-thick"></i>
        </span>
      )}
    </a>
  )
}

export default Button
